import splitDux from 'src/redux/split';

const {
  handleSplitToolConfirmSplit,
  handleConfirmDeleteSplit,
} = splitDux.actions;

/**
 * @param {*} originalType original type of the action being undone/redone
 * @param {*} isUndo Whether the current operation is an undo of something
 * @returns {boolean} Returns boolean to indicate whether this operation will
 * end up creating facades. Used to determine the order of operations. If this
 * action will create facades, we should reverse the order so that parents
 * are created and set to the proper sizes before their children
 */
const isCreatingSplitFacades = (originalType, isUndo) =>
  (originalType === handleSplitToolConfirmSplit.toString() && !isUndo) ||
  (originalType === handleConfirmDeleteSplit.toString() && isUndo);

const undoUtils = {
  isCreatingSplitFacades,
};

export default undoUtils;
